import { z } from 'zod';

export const UrlSettingsSchema = z.object({
  terms_of_service: z.string().nullable(),
  privacy_policy: z.string().nullable(),
  website: z.string().nullable(),
  product_guidelines: z.string().nullable(),
});

export type UrlSettings = z.infer<typeof UrlSettingsSchema>;

export const ThemingFontDefSchema = z.object({
  family: z.string(),
  url: z.string().optional().nullable(),
});

export const ThemingFontsSchema = z.object({
  heading: ThemingFontDefSchema,
  body: ThemingFontDefSchema,
});

export type ThemingFonts = z.infer<typeof ThemingFontsSchema>;

export const ThemingSurfaceSchema = z.object({
  primary: z.string(),
  primary_support: z.string(),
  primary_support_soft: z.string(),
  neutral: z.string(),
  focus: z.string(),
  positive: z.string(),
  positive_support: z.string(),
  warning: z.string(),
  warning_support: z.string(),
  error: z.string(),
  error_support: z.string(),
  shadow: z.string(),
  hover: z.string(),
  video_overlay_button: z.string(),
  modal_overlay: z.string(),
});
export type ThemingSurface = z.infer<typeof ThemingSurfaceSchema>;

export const ThemingBorderSchema = z.object({
  primary: z.string(),
  disabled: z.string(),
  hover: z.string(),
});
export type ThemingBorder = z.infer<typeof ThemingBorderSchema>;

export const ThemingTextSchema = z.object({
  heading: z.string(),
  body: z.string(),
  secondary: z.string(),
  focus: z.string(),
  disabled: z.string(),
  overlay_disabled: z.string(),
});
export type ThemingText = z.infer<typeof ThemingTextSchema>;

export const ThemingSchema = z.object({
  fonts: ThemingFontsSchema,
  surface: ThemingSurfaceSchema,
  border: ThemingBorderSchema,
  text: ThemingTextSchema,
});

export type Theming = z.infer<typeof ThemingSchema>;
